import { render } from "./AiHoursModal.vue?vue&type=template&id=6bfcd16b"
import script from "./AiHoursModal.vue?vue&type=script&lang=js"
export * from "./AiHoursModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiHoursModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bfcd16b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bfcd16b', __exports__)) {
    api.reload('6bfcd16b', __exports__)
  }
  
  module.hot.accept("./AiHoursModal.vue?vue&type=template&id=6bfcd16b", () => {
    api.rerender('6bfcd16b', render)
  })

}


export default __exports__